import { Viewport3DLayerProps } from "./Viewport3DEnvironmentMetadata";
import PropPointPreview from "./PropPointPreview";
import { useSelector } from "react-redux";
import {
  useSequenceDockedPropIds,
  useSequenceRemovedPropIds,
} from "./useSequenceStateOnMap";
import useTakeAttachmentsOnMap from "./useTakeAttachmentsOnMap";
import { selectSelectedTake3D } from "../../app/slices/TrainingSlice";

export default function Viewport3DPropLayer(props: Viewport3DLayerProps) {
  const {
    currentTakeLocation,
    takePositions,
    isCameraSelected,
    collapsedTakeLocationIds = [],
  } = { ...props };
  const situationsInTake = useSelector(selectSelectedTake3D)?.situations;
  const sequenceRemovedPropIds = useSequenceRemovedPropIds();
  // Props an attachment marker draws on top of: in the sequence state, or the take's own riders.
  const takeAttachments = useTakeAttachmentsOnMap();
  const sequenceDockedPropIds = useSequenceDockedPropIds() ?? takeAttachments?.riddenPropIds;

  const propPreviews = takePositions
    .filter((pos) => situationsInTake && !(pos.id in situationsInTake))
    .filter((pos) => !collapsedTakeLocationIds.includes(pos.id))
    .map((point) => {
      if (point.prop_positions)
        return point.prop_positions.map((propPos) => {
          return (
            <PropPointPreview
              animateFrom={point.id !== currentTakeLocation?.id ? { ...point.position, id: point.id } : undefined}
              key={propPos.id}
              x={propPos.position.x}
              y={propPos.position.y}
              positionId={propPos.id}
              sequenceRemovedPropIds={sequenceRemovedPropIds}
              sequenceDockedPropIds={sequenceDockedPropIds}
              positionDirection={propPos.direction}
              takeColor={point.take_color}
              disabled={isCameraSelected}
            />
          );
        });
    });

  return <>{currentTakeLocation && propPreviews}</>;
}
